export const MAP_SETTINGS = {
  DEFAULT_MAP_OPTIONS: {
    // scrollwheel: false,
    mapTypeControl: false,
    // fullscreenControl: true,
    streetViewControl: false,
    restriction: {
      latLngBounds: {
        north: 85,
        south: -85,
        west: -180,
        east: 180
      }
    },
    maxZoom: 5,
    minZoom: 2
  },
  DEFAULT_CENTER: { lat: 57, lng: 20 },
  DEFAULT_ZOOM: 4,
  MARKER_SIZE_X: 60,
  MARKER_SIZE_Y: 30,
  PIXEL_OFFSET: {
    MARKER: {
      X: 0,
      Y: -25
    }
  },
  DIRECTIONS_OPTIONS: { suppressMarkers: true, preserveViewport: true }
};
